import { render } from "./VerticalTimeline.vue?vue&type=template&id=0c013a3e"
import script from "./VerticalTimeline.vue?vue&type=script&lang=js"
export * from "./VerticalTimeline.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__